"use client";

import { useTranslations } from "next-intl";

import { Typography } from "@/components/ui/typography";
import { Link, usePathname } from "@/i18n/routing";
import { SiteConfig } from "@/lib/site-config";
import { ROUTES } from "@/routes";

export const FooterSection = () => {
    const t = useTranslations("legal");

    const pathname = usePathname();

    if (pathname.includes(ROUTES.DASHBOARD.HOME)) return null;

    return (
        <>
            <footer className="border-t bg-accent py-5">
                <div className="mb-4 flex items-center justify-center gap-4 text-base">
                    <Link href={ ROUTES.LEGAL.TERMS_OF_SERVICE } className="underline-offset-4 hover:underline">
                        {t("termsOfService")}
                    </Link>
                    <span>|</span>
                    <Link href={ ROUTES.LEGAL.PRIVACY_POLICY } className="underline-offset-4 hover:underline">
                        {t("privacyPolicy")}
                    </Link>
                </div>
                <Typography variant="muted" className="text-center text-base">
                    &copy; {t("copyright", { year: new Date().getFullYear(), appName: SiteConfig.title })}
                </Typography>
            </footer>
        </>
    );
};